import { ExternalUploadAsset, ExternalUploaderPollHandler } from '@ff-os/pdp-shared-redux/apis/external-upload/externalUploaderPoller';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState, PhotoPrintsPdpStore } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsExternalUploadPayload } from '@ff-scene-plugins/photo-prints-redux/types/PhotoPrintsExternalUploader';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import cuid from 'cuid';

export const createExternalUploadPollListener = (
    { dispatch, getState }: PhotoPrintsPdpStore
): ExternalUploaderPollHandler<PhotoPrintsExternalUploadPayload> => {

    return (assets) => {

        const state = getState() as PhotoPrintsPdpState;
        const groupIds = state.project.groups.ids;

        const newPhotos: PhotoPrintsJson.Photo[] = assets
            .filter(a => groupIds.includes(a.externalUploaderPayload.groupId))
            .map(toNewPhoto);

        dispatch(photoActions.addMany(newPhotos));
    };
};

const toNewPhoto = (
    asset: ExternalUploadAsset<PhotoPrintsExternalUploadPayload>
): PhotoPrintsJson.Photo => ({
    id: cuid(),
    processed: true,
    assetId: asset.assetId,
    groupId: asset.externalUploaderPayload.groupId,
    quantity: 1,
    status: 'saved',
    assetSource: 'private',
    height: asset.meta.height,
    width: asset.meta.width,
    filter: null,
    crop: {
        x: 0,
        y: 0,
        width: asset.meta.width,
        height: asset.meta.height
    },
    autoFaceCenter: true,
    detections: []
});